export enum Currency {
  GBP,
  USD,
  EUR,
  AUD,
}
